import * as Icons from "heroicons-react";
import { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  DataAddSuppliers,
  resetSupplierSlice,
  supplierProducts,
  updateFieldValue,
} from "../../features/supplierSlice";
import {
  useSupplierQuery,
  useUpdateSupplierMutation,
} from "../../services/supplierApi";
import { useUnitsQuery } from "../../services/unitApi";
import SearchProduct from "../Common/CustomSelect/SearchProduct";
import Header from "../Common/Header/Header";
import SupplierProductModal from "../Common/Modal/SupplierProductModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import "./Supplier.css";

const UpdateSupplier = () => {
  let i = 1;
  const { id } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const supplierData = useSelector((state) => state.supplierReducer);

  console.log("Supplier Data", supplierData);

  const getCartData = supplierData.products || [];

  // console.log(id);
  // const [importProducts, setImportProducts] = useState([]);
  // const [pData, setPData] = useState([]);
  const { register, handleSubmit, reset } = useForm({});
  const supplierProductsRef = useRef(null);
  const { data, error, isLoading, isFetching, isSuccess, refetch } =
    useSupplierQuery(`${id}`);
  const { data: unitsList } = useUnitsQuery();

  const getUnitDisplay = (unit) => {
    if (!unit) return "-";
    if (typeof unit === "object") {
      return unit.symbol || unit.name || "-";
    }
    if (typeof unit === "string") {
      if (/^[0-9a-fA-F]{24}$/.test(unit)) {
        const found = unitsList?.find((u) => u._id === unit);
        return found?.symbol || found?.name || "-";
      }
      return unit;
    }
    return String(unit);
  };

  const auth = signInUser();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loader, setLoader] = useState(true);
  console.log("data", data);

  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [isFetching]);

  useEffect(() => {
    refetch();
  }, [id]);

  useEffect(() => {
    if (data) {
      dispatch(DataAddSuppliers(data));
    }
    setLoader(false);
  }, [isSuccess]);

  const importProduct = (e) => {
    e.preventDefault();
    handleShow();
    console.log("clicked");
  };

  useEffect(() => {
    handleReset();
  }, [supplierData]);

  // handel user update
  const [updateSupplier] = useUpdateSupplierMutation();

  // ADD TO LIST
  const addToList = async (data) => {
    // console.log(data);
    if (data) {
      console.log("add to list:", data);
      await supplierProductsRef?.current?.blur();
      // const getData = JSON.parse(localStorage.getItem("supplier_cart"));
      let listData = getCartData ? getCartData : [];
      console.log("old:", listData);

      let newProduct = {};
      // unique check
      const idExist = listData.find((pro) => pro?.id === data?._id);
      console.log(idExist);
      if (idExist) {
        notify("Product Already in List", "error");
        // console.log()
      } else {
        const resolvedUnit =
          typeof data?.unit === "object" && data?.unit !== null
            ? (data.unit.symbol || data.unit.name || "pcs")
            : (typeof data?.unit === "string" && /^[0-9a-fA-F]{24}$/.test(data.unit)
              ? (unitsList?.find((u) => u._id === data.unit)?.symbol ||
                 unitsList?.find((u) => u._id === data.unit)?.name ||
                 "pcs")
              : data?.unit || "pcs");

        newProduct = {
          id: data._id,
          name: data.name,
          article_code: data.article_code,
          ean: data.ean,
          unit: resolvedUnit,
          aamarId: auth?.aamarId,
          warehouse: auth?.warehouse,
          order: listData.length + 1,
        };
        listData = [...listData, newProduct];
      }

      dispatch(supplierProducts(listData));

      supplierProductsRef.current.focus();
    } else {
      return false;
    }
  };

  //FORM RESET
  const handleReset = () => {
    reset({
      name: supplierData.name,
      email: supplierData.email,
      code: supplierData.code,
      company: supplierData.company,
      type: supplierData.type,
      address: supplierData.address,
      phone: supplierData.phone,
      status: supplierData.status,
    });
  };

  const handleFieldChange = (field, value) => {
    dispatch(updateFieldValue({ field, value }));
  };

  const removeFromCart = (id) => {
    const restData = getCartData?.filter((pro) => pro?.id !== id);
    dispatch(supplierProducts(restData));
  };

  const updateHandler = async (data) => {
    const response = await updateSupplier({
      ...supplierData,
      _id: id,
    }).unwrap();
    if (response) {
      console.log("response", response);
      notify("Supplier Update Successful!", "success");
      // localStorage.removeItem("supplier_cart");

      // Refetch the updated data

      dispatch(resetSupplierSlice());

      // Optionally navigate if needed
      navigate("/supplier");
      refetch();
    }
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header
              title={data?._id ? "Update Supplier" : "Add Supplier"}
            ></Header>
            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <div className=" mt-4 pb-4">
                    <div className="card-body">
                      <form onSubmit={handleSubmit(updateHandler)}>
                        <div className="row mb-3">
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="inputSupplierCompany">Supplier Company</label> */}
                            <input type="hidden" {...register("_id")} />
                            <input
                              {...register("company", { required: true })}
                              type="text"
                              className="form-control"
                              id="inputSupplierCompany"
                              aria-describedby="emailHelp"
                              placeholder="Supplier Company"
                              onChange={(e) =>
                                handleFieldChange("company", e.target.value)
                              }
                            />
                            <small
                              id="emailHelp"
                              className="form-text text-muted"
                            >
                              We'll never share your email with anyone else.
                            </small>
                          </div>
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="inputSupplier">Supplier Name</label> */}
                            <input
                              {...register("name", { required: true })}
                              type="text"
                              className="form-control"
                              id="inputSupplier"
                              aria-describedby="emailHelp"
                              placeholder="Supplier Name"
                              onChange={(e) =>
                                handleFieldChange("name", e.target.value)
                              }
                            />
                            <small
                              id="emailHelp"
                              className="form-text text-muted"
                            >
                              We'll never share your email with anyone else.
                            </small>
                          </div>
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="inputEmail">Supplier Email</label> */}
                            <input
                              {...register("email", { required: true })}
                              type="email"
                              className="form-control"
                              id="inputEmail"
                              aria-describedby="emailHelp"
                              placeholder="Supplier Email"
                              onChange={(e) =>
                                handleFieldChange("email", e.target.value)
                              }
                            />
                            <small
                              id="emailHelp"
                              className="form-text text-muted"
                            >
                              We'll never share your email with anyone else.
                            </small>
                          </div>
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="inputMC">Supplier Phone</label> */}
                            <input
                              {...register("phone")}
                              type="text"
                              className="form-control"
                              id="phone"
                              placeholder="Supplier Phone"
                              onChange={(e) =>
                                handleFieldChange("phone", e.target.value)
                              }
                            />
                          </div>
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="COde">COde</label> */}
                            <input
                              {...register("code")}
                              type="text"
                              className="form-control"
                              id="code"
                              readOnly
                              placeholder="Supplier Code"
                              onChange={(e) =>
                                handleFieldChange("code", e.target.value)
                              }
                            />
                          </div>
                          <div className="form-group col-4  mb-3">
                            {/* <label htmlFor="status">Status</label> */}
                            <select
                              {...register("status")}
                              className="form-select"
                              id="status"
                              onChange={(e) =>
                                handleFieldChange("status", e.target.value)
                              }
                            >
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                          </div>
                          <div className="form-group col-12  mb-3">
                            {/* <label htmlFor="address">Address</label> */}
                            <textarea
                              {...register("address")}
                              className="form-control"
                              id="address"
                              placeholder="Address"
                              onChange={(e) =>
                                handleFieldChange("address", e.target.value)
                              }
                            />
                          </div>
                        </div>
                        {/* SEARCH PRODUCT */}
                        <div className="row ">
                          <div className="col-10 mb-3">
                            <p className="mb-1">
                              <b>Supplier's Products</b>
                            </p>
                            <SearchProduct
                              className="searchProduct"
                              // getValue={getValue}
                              addToList={addToList}
                              supplierProductsRef={supplierProductsRef}
                            ></SearchProduct>
                            {/* <ProductSearch
                            addToCart={addToCart}
                            searchResult={searchResult}
                            handleProductOnChange={handleProductOnChange}
                          /> */}
                          </div>
                          <div className="col-md-2 mb-md-3 mt-md-4">
                            <button
                              className="btn btn-dark btn-block "
                              onClick={importProduct}
                            >
                              <Icons.Plus> </Icons.Plus>
                              Import Products
                            </button>
                          </div>
                        </div>
                        <div className="col-12 mb-3">
                          {/* <p className="mb-1">
                            <b>Supplier's Products</b>
                          </p>
                          <SearchProduct
                            className="searchProduct"
                            // getValue={getValue}
                            addToList={addToList}
                            supplierProductsRef={supplierProductsRef}
                          ></SearchProduct> */}
                          <div className="card mt-3 p-2">
                            <Table>
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>EAN</th>
                                  <th>Name</th>
                                  <th>Code</th>
                                  <th>Unit</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {getCartData && getCartData.length > 0 ? (
                                  getCartData
                                    // ?.sort((a, b) => b.order - a.order)
                                    .map((item, idx) => (
                                      <tr key={item?.id || item?.article_code || idx}>
                                        <th>{idx + 1}</th>
                                        <td>{item?.ean}</td>
                                        <td>{item?.name}</td>
                                        <td>{item?.article_code}</td>
                                        <td>{getUnitDisplay(item?.unit)}</td>
                                        <td>
                                          <Icons.X
                                            size={20}
                                            onClick={() =>
                                              removeFromCart(item.id)
                                            }
                                          ></Icons.X>
                                        </td>
                                      </tr>
                                    ))
                                ) : (
                                  <tr>
                                    <td colSpan={6}>
                                      <p className="text-center m-2">
                                        Please select product
                                      </p>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </div>

                        <button
                          type="submit"
                          className="btn btn-dark float-end "
                        >
                          <Icons.SaveOutline size={18} className="mx-2" />
                          Update Supplier
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline float-end mx-3"
                          onClick={() => dispatch(resetSupplierSlice())}
                        >
                          <Icons.X size={18} className="mx-2" />
                          Cancle
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster position="bottom-right" />
      <SupplierProductModal
        show={show}
        setShow={setShow}
        handleClose={handleClose}
        // handleImportButton={handleImportButton}
      ></SupplierProductModal>
    </div>
  );
};

export default UpdateSupplier;
